module.exports = __webpack_public_path__ + "img/2024_01.e8242838.jpg";